import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';

export const mockNoUserLoggedIn: MockResponseConfig = {
  AtlassianAccountUserQuery: (variables: Variables) => ({
    data: {
      me: {
        user: {
          __typename: 'AtlassianAccountUser',
          accountId: '712020:0189aab4-6460-4699-a05b-939927f7ebea',
          accountStatus: 'active',
          name: 'Logged In',
          email: 'loggedin@atlassian.com',
          nickname: 'Logged In',
          picture:
            'https://avatar-management--avatars.us-west-2.staging.public.atl-paas.net/62587f99fdb60b0069294184/e0b9d132-d806-4550-b390-c12f308e5a30/128',
          id: 'ari:cloud:identity::user/712020:0189aab4-6460-4699-a05b-939927f7ebea',
        },
      },
    },
  }),
  UnifiedSystemMutation: (variables: Variables) => ({
    data: {
      unified: {
        createUnifiedSystem: {
          errors: [],
          success: true,
          unifiedProfile: {
            bio: '<p>Hi I\'m an engineer at <a target="_blank" rel="noopener noreferrer nofollow" href="http://www.atlassian.com">Atlassian</a>.</p>',
            company: 'Nike',
            aaid: '62587f99fdb60b0069294184',
            id: 'ari:cloud:unified-portable-profile::unified-profile/c34de571-576f-45e6-8c02-0917609af889',
            linkedinUrl: 'linkedin.com/colbystauss',
            location: 'Utah, USA',
            accountInternalId: '541b9286-8563-4825-aae8-43e7e90fb493',
            products: null,
            role: 'CEO',
            internalId: 'c34de571-576f-45e6-8c02-0917609af889',
            username: 'fullloggedin',
            websiteUrl: 'colbystauss.net',
            xUrl: null,
            youtubeUrl: null,
            isPrivate: false,
            isPersonalView: true,
            isLinkedView: false,
          },
        },
      },
    },
  }),
};
